import * as React from 'react';

interface HeaderRegionProps {
  className: string;
}

export class HeaderRegion extends React.Component<HeaderRegionProps> {
  public render() {
    const classes = ['header-region', 'pwa-toolbar__row', this.props.className].filter(val => val).join(' ');

    return <section className={classes}>{this.props.children}</section>;
  }
}
